module.exports = __webpack_public_path__ + "static/media/booking.4959846f.svg";